import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1565C0',
        secondary: '#455A64',
        accent: '#0288D1',
        error: '#D32F2F',
        warning: '#F57C00',
        info: '#0288D1',
        success: '#2E7D32',
        background: '#FAFBFC',
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
